import React from 'react';
import { PageContainer } from 'src/tef/components/layout/PageContainer';
import { ContainerBox } from 'src/tef/components/primitives/ContainerBox';
import { cn } from 'src/tef/components/utils/cn';

interface FullPageLayoutProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

export const FullPageLayout: React.FC<FullPageLayoutProps> = ({ children, className, contentClassName }) => {
  return (
    <PageContainer className={cn('w-full max-w-none py-8 px-2 sm:px-4 flex flex-col flex-1 min-h-0', className)}>
      <ContainerBox className={cn('w-full min-w-0 flex flex-col flex-1 min-h-0', contentClassName)}>
        {children}
      </ContainerBox>
    </PageContainer>
  );
};
